import { EsqueletoDeCartao, EstadoDeErro } from "@base/ui";
import { mensagemDoErro } from "../../../shared/http/mensagem-de-erro";
import { useMarcarAlertaComoVisto, useResolverAlerta, useVisaoGeral } from "../application/central.contexto";
import { PaginaDeCentral } from "./pagina-de-central";

/** Visao geral buscada na API, com carregando e erro no padrao do Dashboard. */
export function CentralAoVivo() {
  const consulta = useVisaoGeral();
  const marcar = useMarcarAlertaComoVisto();
  const resolver = useResolverAlerta();

  if (consulta.isPending) return <EsqueletoDeCartao rotulo="Carregando a Central" />;
  if (consulta.isError) {
    return <EstadoDeErro mensagem={mensagemDoErro(consulta.error)} aoTentarNovamente={() => void consulta.refetch()} />;
  }

  return (
    <PaginaDeCentral
      visao={consulta.data}
      aoMarcarComoVisto={(id) => {
        void marcar.mutateAsync(id).then(() => consulta.refetch()).catch(() => undefined);
      }}
      aoResolver={(id, nota) => {
        void resolver.mutateAsync({ id, nota }).then(() => consulta.refetch()).catch(() => undefined);
      }}
    />
  );
}
